import { isProduction } from 'utils';

const Sentry = () => window.Raven;

export const logger = log => {
  if (!log.error)
    throw new Error('Parameter should be an object with an error method');
  return {
    error: message => {
      log.error(new Error(message));
    },
  };
};

export const sentryAdaptor = (tool = Sentry(), isProd = isProduction()) => {
  return {
    error:
      isProd &&
      tool !== 'undefined' &&
      typeof tool === 'object' &&
      Object.hasOwnProperty.call(tool, 'captureException')
        ? tool.captureException
        : console.error, // eslint-disable-line no-console
  };
};

export default logger(sentryAdaptor());
